export default class DeferredPromise<T> {
	private _resolve!: (value: T | PromiseLike<T>) => void;
	private _reject!: (reason?: any) => void;

	public promise!: Promise<T>;

	public constructor() {
		this.reset();
	}

	public static new<T>(): DeferredPromise<T> {
		return new this<T>();
	}

	public reset(): DeferredPromise<T> {
		this.promise = new Promise<T>((resolve, reject) => {
			this._resolve = resolve;
			this._reject = reject;
		});
		return this;
	}

	public resolve(value: T | PromiseLike<T>): void {
		this._resolve(value);
	}

	public reject(reason?: any): void {
		this._reject(reason);
	}
}
